<template>
  <div class="svoice-switch" @click="switchData" :class="{right: switchFlag}">
    <span class="circle"></span>
  </div>
</template>

<script>
export default {
  name: 'svoice-switch',
  props: {
    defaultValue: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      switchFlag: this.defaultValue
    }
  },
  watch: {
    reset () {
      this.init()
    }
  },
  created(){
    this.init()
  },
  methods: {
    init() {
      this.switchFlag = this.defaultValue
      this.$emit('switchData', this.switchFlag)
    },
    switchData () {
      const switchFlag = !this.switchFlag
      this.switchFlag = switchFlag;
      this.$emit('switchData', switchFlag)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.svoice-switch {
  position: relative;
  width: 26px;
  height: 16px;
  background: #E0E0E0;
  border-radius: 8px;
  cursor: pointer;
  .circle {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 14px;
    height: 14px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(111, 111, 111, 0.5);
    border-radius: 7px;
  }
  &.right {
    background: #4E6EFF;
    .circle {
      right: 1px;
      left: unset;
    }
  }
}
</style>
